import { SeasonLink as Link } from "../../components/Seasons/SeasonLink";
import {
  Arrow,
  NewsArtwork,
  NewsCard,
  NewsStatus,
  useNewsResource,
} from "./NewsComponents";
import styles from "./news.module.css";

export function LandingNews() {
  const resource = useNewsResource({ limit: 3 });
  const items = resource.data?.items || [];
  return (
    <section
      className={styles.landingSection}
      id="news"
      aria-labelledby="landing-news-title"
    >
      <div className={styles.landingHeading}>
        <div>
          <span className={styles.eyebrow}>МЕДИА / ЮФУ.ПРО</span>
          <h2 id="landing-news-title">
            Актуальная <span>информация</span>
          </h2>
        </div>
        <Link to="/news" className={styles.allNews}>
          Все новости <Arrow diagonal />
        </Link>
      </div>
      <NewsStatus resource={resource} />
      {!resource.loading &&
        !resource.error &&
        (items.length ? (
          <div
            className={`${styles.landingGrid} ${items.length === 1 ? styles.singleStory : ""}`}
          >
            <NewsCard article={items[0]} featured />
            {items.length > 1 && (
              <div className={styles.sideStories}>
                {items.slice(1).map((article) => (
                  <NewsCard key={article.id} article={article} compact />
                ))}
                <Link to="/news" className={styles.moreStories}>
                  Больше историй и идей <Arrow />
                </Link>
              </div>
            )}
          </div>
        ) : (
          <div className={styles.editorialHero}>
            <div className={styles.heroCopy}>
              <span className={styles.eyebrow}>
                <i /> СКОРО В ЭФИРЕ
              </span>
              <h3>
                Большие идеи.
                <br />
                <span>Живые истории.</span>
              </h3>
              <p>
                События, победы команд и всё, чем живёт ЮФУ.Про. Первые
                публикации уже на подходе.
              </p>
              <Link to="/news" className={styles.heroLink}>
                Перейти к новостям <Arrow diagonal />
              </Link>
            </div>
            <NewsArtwork />
          </div>
        ))}
    </section>
  );
}
